import { ComponentProps } from "react";
import defaultMastheadImage50 from "@assets/logo-bt-masthead-50.png";
import Edition from "@features/banner/Edition/Edition";
import { cn } from "@util/helpers";

import LogoMasthead, { LogoMastheadProps } from "./LogoMasthead/LogoMasthead";

export type MastheadProps = {
  /** Component to be rendered below the masthead */
  componentBelowMasthead?: React.ReactNode;
  /** Optional className for the masthead */
  className?: string;
  /** Optional indicator display edition switcher */
  isDisplayEditionSwitcher?: boolean;
  /** Flag to display h1 or not */
  isDisplayH1?: boolean;
  /** The ref code to be added the links. */
  editionRef?: string;
} & LogoMastheadProps &
  Pick<ComponentProps<typeof Edition>, "theme">;

export default function HomepageMasthead({
  componentBelowMasthead,
  className,
  isDisplayEditionSwitcher,
  theme,
  isDisplayH1 = false,
  editionRef,
  ...logoMastheadProps
}: MastheadProps): React.ReactElement {
  return (
    <div className={cn("hidden py-7 lg:block", className)}>
      <Edition
        className="mb-2 text-center uppercase"
        theme={theme}
        editionRef={editionRef}
      />

      <div className="relative flex w-full flex-row items-center justify-center gap-3">
        <LogoMasthead
          {...logoMastheadProps}
          isDisplayH1={isDisplayH1}
          rootClassName={"flex justify-center"}
        />
        <img
          src={defaultMastheadImage50}
          alt="business-time-50"
          width={isDisplayH1 ? 100 : 68}
          height={isDisplayH1 ? 63 : 43}
        />
      </div>

      <>{componentBelowMasthead}</>
    </div>
  );
}
